export const transformBooleanString = (string: string | undefined): boolean => {
  return string === 'true';
};
